class HavenVariantPicker {
  constructor(container) {
    this.container = container;
    this.productId = container.dataset.productId;
    this.variantSelect = this.container.querySelector('.haven-variant-select') || 
                        document.querySelector(`#productSelect-${this.productId}`) ||
                        document.querySelector('[name="id"]');
    
    this.initProductData();
    this.initButtons();
  }

  initProductData() {
    try {
      const jsonElement = document.getElementById(`ProductJson-${this.productId}`) || 
                         document.getElementById('ProductJson') ||
                         document.querySelector('[type="application/json"][id*="ProductJson"]');
      
      if (!jsonElement) {
        this.productData = this.buildProductDataFromSelect();
      } else {
        this.productData = JSON.parse(jsonElement.textContent);
      }
    } catch (e) {
      this.productData = this.buildProductDataFromSelect();
    }
  }

  buildProductDataFromSelect() {
    if (!this.variantSelect) return null;
    
    const variants = Array.from(this.variantSelect.options).map(option => {
      const [title, price] = option.text.split(' - ');
      const options = title.split(' / ');
      const priceValue = parseFloat((price || '0').replace(/[^\d.]/g, '')) * 100;
      
      return {
        id: option.value,
        title: title,
        options: options,
        available: !option.disabled,
        price: priceValue,
        compare_at_price: null
      };
    });

    return { variants };
  }

  initButtons() {
    const buttons = this.container.querySelectorAll('.haven-option-button');
    buttons.forEach(button => {
      button.addEventListener('click', (e) => this.onButtonClick(e));
    });
  }

  updateVariantSelect(selectedOptions) {
    if (!this.variantSelect || !this.productData) return;

    const matchingVariant = this.productData.variants.find(variant => 
      variant.options.every((option, index) => option === selectedOptions[index])
    );

    if (matchingVariant) {
      // Update the select value
      this.variantSelect.value = matchingVariant.id;

      // Trigger standard change event
      const event = new Event('change', { bubbles: true });
      this.variantSelect.dispatchEvent(event);
      
      // Update UI
      this.updatePriceDisplay(matchingVariant);
      this.updateProductImage(matchingVariant);
      
      // Trigger Shopify's variant change handlers
      if (window.Shopify?.onVariantChange) {
        window.Shopify.onVariantChange(matchingVariant);
      }

      // Dispatch our custom event
      this.variantSelect.dispatchEvent(new CustomEvent('variant:changed', {
        detail: { variant: matchingVariant },
        bubbles: true
      }));
    }
  }

  updatePriceDisplay(variant) {
    const regularPriceElement = document.querySelector(`#productPrice-template--${this.productId}__main .money`);
    const comparePriceElement = document.querySelector(`#comparePrice-template--${this.productId}__main .money`);

    if (!regularPriceElement) {
      const priceContainer = document.querySelector('.offers .price:not(.striped)');
      if (priceContainer) {
        const moneySpan = priceContainer.querySelector('.money');
        if (moneySpan) {
          moneySpan.setAttribute('data-currency-cad', variant.price);
          moneySpan.innerHTML = this.formatMoney(variant.price);
        }
      }
    } else {
      regularPriceElement.setAttribute('data-currency-cad', variant.price);
      regularPriceElement.innerHTML = this.formatMoney(variant.price);
    }

    if (comparePriceElement) {
      const compareAtPrice = variant.compare_at_price || null;
      if (compareAtPrice && compareAtPrice > variant.price) {
        comparePriceElement.setAttribute('data-currency-cad', compareAtPrice);
        comparePriceElement.innerHTML = this.formatMoney(compareAtPrice);
        comparePriceElement.closest('.price.striped').style.display = '';
      } else {
        comparePriceElement.closest('.price.striped').style.display = 'none';
      }
    }

    // Update ZIP payment widget if it exists
    const zipWidget = document.querySelector('[data-zm-widget="popup"]');
    if (zipWidget) {
      zipWidget.setAttribute('data-zm-price', (variant.price / 100).toFixed(2));
      if (window.Zip?.Checkout?.update) {
        window.Zip.Checkout.update();
      }
    }
  }
  formatMoney(cents) {
    if (window.Shopify?.formatMoney) {
      return window.Shopify.formatMoney(cents, window.theme?.moneyFormat);
    }
    
    // Fallback formatter
    const formatString = window.theme?.moneyFormat || '${{amount}}';
    const value = (cents / 100).toFixed(2);
    
    return formatString
      .replace('{{amount}}', value)
      .replace('{{amount_no_decimals}}', Math.floor(value))
      .replace('{{amount_with_comma_separator}}', value.replace('.', ','));
  }

  updateProductImage(variant) {
    const mediaWrappers = document.querySelectorAll('[data-product-single-media-wrapper]');
    if (!mediaWrappers.length) return;

    const variantMediaId = variant.featured_media?.id || variant.media?.[0]?.id;
    
    // Try to find matching wrapper
    let matchingWrapper = Array.from(mediaWrappers).find(wrapper => {
      const wrapperId = wrapper.id;
      const dataMediaId = wrapper.dataset.mediaId;
      return wrapperId === `${variantMediaId}` || 
             dataMediaId === `template--${this.productId}__main-${variantMediaId}`;
    });

    if (!matchingWrapper) {
      matchingWrapper = Array.from(mediaWrappers).find(wrapper => {
        const dataId = wrapper.dataset.mediaId?.split('-').pop();
        return dataId === `${variantMediaId}`;
      });
    }

    if (matchingWrapper) {
      // Hide all media wrappers first
      mediaWrappers.forEach(wrapper => wrapper.classList.add('hide'));
      // Show the matching wrapper
      matchingWrapper.classList.remove('hide');
    } else {
      // Fallback to first image
      mediaWrappers[0]?.classList.remove('hide');
    }
  }

  formatMoney(cents) {
    if (window.Shopify?.formatMoney) {
      return window.Shopify.formatMoney(cents, window.theme?.moneyFormat);
    }
    
    const formatString = window.theme?.moneyFormat || '${{amount}}';
    const value = (cents / 100).toFixed(2);
    
    return formatString
      .replace('{{amount}}', value)
      .replace('{{amount_no_decimals}}', Math.floor(value))
      .replace('{{amount_with_comma_separator}}', value.replace('.', ','));
  }

  onButtonClick(event) {
    event.preventDefault();
    const button = event.target;
    const optionWrapper = button.closest('.haven-option-values');
    
    if (!optionWrapper) return;
    
    // Update button states
    const buttons = optionWrapper.querySelectorAll('.haven-option-button');
    buttons.forEach(btn => btn.classList.remove('selected'));
    button.classList.add('selected');
    
    // Update the label
    const optionLabel = optionWrapper.closest('.haven-option-wrapper').querySelector('.haven-option-label');
    if (optionLabel) {
      const baseLabel = optionLabel.querySelector('strong').textContent;
      optionLabel.innerHTML = `<strong>${baseLabel}</strong> - ${button.textContent.trim()}`;
    }
    
    // Get all selected options
    const selectedButtons = this.container.querySelectorAll('.haven-option-button.selected');
    const selectedOptions = Array.from(selectedButtons).map(btn => btn.dataset.optionValue);
    
    this.updateVariantSelect(selectedOptions);
  }
}

// Initialize
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initVariantPicker);
} else {
  initVariantPicker();
}

function initVariantPicker() {
  const containers = document.querySelectorAll('.haven-variant-selectors');
  containers.forEach(container => new HavenVariantPicker(container));
}